import { render, staticRenderFns } from "./DigitalHuman.vue?vue&type=template&id=e496f136&scoped=true"
import script from "./DigitalHuman.vue?vue&type=script&lang=js"
export * from "./DigitalHuman.vue?vue&type=script&lang=js"
import style0 from "./DigitalHuman.vue?vue&type=style&index=0&id=e496f136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e496f136",
  null
  
)

export default component.exports